const consentManager = require('../json/consent-manager.json')

/**
 * Consent Manager class
 */
class ConsentManager {
  static getConsent (data) {
    if (Array.isArray(data) && data.length) {
      return data[data.length - 1]
    }

    return null
  }

  /**
   * Return latest hash from terms of use
   * @returns string
   */
  static getTermsOfUseHash () {
    const termsOfUse = ConsentManager.getConsent(consentManager.termsOfUse)
    return termsOfUse.hash
  }

  /**
   * Return latest hash from privacy policy
   * @returns string
   */
  static getPrivacyPolicyHash () {
    const privacyPolicy = ConsentManager.getConsent(consentManager.privacyPolicy)
    return privacyPolicy.hash
  }

  /**
   * Return latest hash from promotion/offers
   * @returns string
   */
  static getPromotionOffersHash () {
    const promotionOffers = ConsentManager.getConsent(consentManager.promotionOffers)
    return promotionOffers.hash
  }

  /**
   * Return latest hash from subscription contract
   * @returns string
   */
  static getSubscriptionContractHash () {
    const subscriptionContract = ConsentManager.getConsent(consentManager.subscriptionContract)
    return subscriptionContract.hash
  }
}

module.exports.ConsentManager = ConsentManager
